import { connect } from "react-redux";
import { showSnackbarNotification } from "store/notification/notification.actions";
import { setCurrentTab } from "store/siteCoordinator/siteCoordinator.actions";
import {
  viewPodCastStart,
  fetchPodCastEpisodeStart,
  fetchApplePodcastEpisodeStart,
  fetchListenNotesPodcastEpisodeStart,
} from "store/podcast/podcast.actions";
import {
  // addPlayPodcastStart,
  getNextFavoriteStart,
  getNextHistoryStart,
  podcastHeartStart,
  removeFavoritePodcastStart,
  removeHistoryPodcastStart,
} from "store/userHistoryPodcast/userHistoryPodcast.actions";
import { setCurrentViewdPodPlaylist } from "store/podcastPlaylist/podcastPlaylist.actions";

const mapStateToProps = (state) => ({
  userState: state.user,
  podcastState: state.podcast,
  userHistoryPodcastState: state.userhistoryPodcast,
});

const mapDispatchToProps = (dispatch) => ({
  onSetCurrentTab: (value) => dispatch(setCurrentTab(value)),
  onViewPodCastStart: (value) => dispatch(viewPodCastStart(value)),
  onFetchPodCastEpisode: (podcastId) =>
    dispatch(fetchPodCastEpisodeStart(podcastId)),
  onFetchApplePodcastEpisode: (value) =>
    dispatch(fetchApplePodcastEpisodeStart(value)),
  onFetchListenNotesPodcastEpisode: (value) =>
    dispatch(fetchListenNotesPodcastEpisodeStart(value)),
  onGetNextFavoriteStart: (cursor, limit) =>
    dispatch(getNextFavoriteStart(cursor, limit)),
  onGetNextHistoryStart: (cursor, limit) =>
    dispatch(getNextHistoryStart(cursor, limit)),
  onFavouritePodcast: (id, podcast) => dispatch(podcastHeartStart(id)),
  onRemoveFavoritePodcast: (id) => dispatch(removeFavoritePodcastStart(id)),
  onDeleteHistoryPodcast: (id) => dispatch(removeHistoryPodcastStart(id)),
  onSetCurrentViewdPodPlaylist: (podcastId) =>
    dispatch(setCurrentViewdPodPlaylist(podcastId)),
  onShowSnackbarNotification: (message) =>
    dispatch(showSnackbarNotification(message)),
});

const container = connect(mapStateToProps, mapDispatchToProps);

export default container;
